function passiveEvents() {
    // Test via a getter in the options object to see if the passive property is accessed
    var supports = false;

    try {
        var opts = {};

        Object.defineProperty(opts, 'passive', {
            get: function get() {
                supports = true;
            }
        });

        window.addEventListener('_test', null, opts);
    } catch (e) {
        // Passive events are not supported
    }

    return supports;
}

var prefixedEvents = {
    animationend: {
        animation: 'animationend',
        WebkitAnimation: 'webkitAnimationEnd'
    },
    transitionend: {
        transition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd'
    }
};

var fallbackEvents = {
    beforeunload: 'pagehide'
};

var supports = { passive: passiveEvents() };

function prefixEvent(type) {
    if (type in prefixedEvents && document.documentElement) {
        for (var key in prefixedEvents[type]) {
            if (key in document.documentElement.style) {
                return prefixedEvents[type][key];
            }
        }
    }

    return type;
}

function fallback(el, type) {
    var eventFunc = 'on' + type,
        fallbackFunc = 'on' + fallbackEvents[type];

    if (eventFunc in el || !(fallbackFunc in el)) {
        return type;
    } else {
        return fallbackEvents[type];
    }
}

function addSingleEvent(el, type, fn, useCapture) {
    var eventName = prefixEvent(fallback(el, type));

    // fallback to false if passive event listeners are not supported
    if (!supports.passive && typeof useCapture === 'object') {
        useCapture = false;
    }

    el.addEventListener(eventName, fn, useCapture);

    return el.removeEventListener.bind(el, eventName, fn, useCapture);
}

function call(fn) {
    fn();
}

function addEvent(el, typeList, fn, useCapture) {
    var attachedEvents = typeList.split(' ').map(function (eventName) {
        return addSingleEvent(el, eventName, fn, useCapture);
    });

    return function () {
        attachedEvents.forEach(call);
    };
}

export { addEvent };
